import React, { useContext, useEffect, useState, useRef } from 'react'
import { QlikReport } from './QlikReport'
import { useReportsQlikApi } from '../api/reportsQlik/reportsQlik.api'
import { QlikUIContext } from '../QlikUIContext'
import { useQlik } from './RequireQlik'
import { useTheme, makeStyles, Card } from '@material-ui/core'
import { stylesMui } from './styles/report.styles'

export const Report = ({ fileName, reportType, dimensions }) => {
  const context = useContext(QlikUIContext)
  const [qlikLoaded, qlik] = useQlik()
  const apiReportsQlik = useReportsQlikApi()
  const container = useRef()

  const currentTheme = useTheme()
  const useStyles = makeStyles(stylesMui(currentTheme))
  const classes = useStyles()

  const [report, setReport] = useState(undefined)

  async function getReport() {
    setReport(
      await apiReportsQlik.GetReport(context.userName, fileName, reportType)
    )
  }

  useEffect(() => {
    if (qlikLoaded) {
      getReport()
    }
  }, [qlikLoaded])

  return (
    <Card elevation={1} className={classes.cardContainer}>
      <div className='content' ref={container}>
        {report && (
          <QlikReport
            qlik={qlik}
            report={report}
            reportType={`${reportType}`}
            onEditReport={() => {}}
            transformRatio={container.current.clientWidth / 24}
            dimensions={dimensions}
          ></QlikReport>
        )}
      </div>
    </Card>
  )
}
